<!-- <img class="close_button" (click)="closeDialog()" src="assets/images/Close_btn.svg"> -->

<div class="popup-container">
    <button mat-button mat-dialog-close (click)="closeDialog()" class="close black-button">X</button>

    <h2 class="p-3 mb-0 roboto-medium">Confirm Deletion</h2>
    <hr id="shadow">
    <br>
    <div>
        <p class="paragraph">Deleting this event will be permanent, and cannot be reversed. Are you sure you want to delete this event?
        </p>
    </div>
    <div class="right-align">
        <button (click)="close()" class="cancel me-3 ms-3 roboto-bold"> CANCEL </button>
        <button (click)="deleteEvent()" class="deletebutt roboto-medium"> DELETE </button>
    </div>


</div>